// Shared styles and constants for mapping components

export const GOAL_EMOJIS: Record<string, string> = {
  return_offer: '🎯',
  skill_learning: '📚',
  networking: '🤝',
  portfolio: '💼',
  custom: '🎯'
};

export const getMappingStyles = (darkMode: boolean) => ({
  textColor: darkMode ? 'text-gray-100' : 'text-gray-900',
  mutedTextColor: darkMode ? 'text-gray-400' : 'text-gray-600',
  borderColor: darkMode ? 'border-gray-700' : 'border-gray-200',
  cardBg: darkMode ? 'bg-gray-800' : 'bg-gray-50',
  activeCardBg: darkMode ? 'bg-gray-700' : 'bg-blue-50',
  hoverBg: darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100',
  linkColor: darkMode ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-700',
  checkboxColor: 'text-blue-500',
  sectionBg: darkMode ? 'bg-gray-800' : 'bg-gray-50'
});